export default "__VITE_ASSET__93803cd7__"